import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  const forYou = ['Mujeres y hombres que buscan una rutina de cuidado personal minimalista pero potente.', 'Personas con piel sensible que reaccionan negativamente a la cosmética industrial.', 'Quienes desean ahorrar dinero creando sus propios productos de alta gama en casa.', 'Amantes del bienestar que valoran los rituales de autocuidado consciente.'];
  const notForYou = ['Quienes buscan soluciones estéticas invasivas o cirugías.', 'Personas que no están dispuestas a dedicar 15 minutos a un ritual natural.', 'Quienes prefieren seguir comprando marcas comerciales por el estatus y no por los resultados.'];
  return <section className="py-24 px-4 bg-botanical-ivory-dark" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-8" data-id="element-3">
          {/* Para ti si... */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-white p-8 md:p-10 rounded-sm border-t-4 border-botanical-sage shadow-sm" data-id="element-4">
            <h3 className="text-2xl font-playfair text-botanical-forest mb-8" data-id="element-5">
              Esta guía es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-6">
              {forYou.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-7">
                  <div className="mt-1 bg-botanical-sage/20 p-1 rounded-full shrink-0" data-id="element-8">
                    <Check size={16} className="text-botanical-forest" data-id="element-9" />
                  </div>
                  <span className="text-botanical-forest/80 font-lora" data-id="element-10">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* No es para ti si... */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-white p-8 md:p-10 rounded-sm border-t-4 border-botanical-terracotta shadow-sm opacity-90" data-id="element-11">
            <h3 className="text-2xl font-playfair text-botanical-forest mb-8" data-id="element-12">
              No es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-13">
              {notForYou.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-14">
                  <div className="mt-1 bg-botanical-terracotta/10 p-1 rounded-full shrink-0" data-id="element-15">
                    <X size={16} className="text-botanical-terracotta" data-id="element-16" />
                  </div>
                  <span className="text-botanical-forest/70 font-lora" data-id="element-17">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}